<div class="w-full">
  @if (label) {
    <label class="mb-3 block text-sm font-medium text-slate700">
      {{ label }}
      @if (required) {
        <span class="ml-1 text-red600">*</span>
      }
    </label>
  }

  <div
    class="flex"
    [ngClass]="{
      'flex-row flex-wrap': direction === 'row',
      'flex-col': direction === 'column',
      'gap-4': variant === 'plain',
      'gap-3': variant !== 'plain' && direction === 'row',
      'gap-2': variant !== 'plain' && direction === 'column'
    }"
    role="radiogroup"
    [attr.aria-label]="label || 'Radio group'"
    >
    @for (option of options; track trackByValue($index, option)) {
      @if (variant === 'check-card') {
        <label
          class="flex items-center justify-between gap-3 rounded-lg border px-4 py-3 transition-all duration-200"
          [ngClass]="{
            'flex-1': stretch,
            'border-indigo600 bg-indigo50': isOptionSelected(option) && !isOptionDisabled(option),
            'border-slate300 bg-white hover:border-slate400': !isOptionSelected(option) && !isOptionDisabled(option),
            'cursor-not-allowed border-slate200 bg-slate100 opacity-60': isOptionDisabled(option),
            'cursor-pointer': !isOptionDisabled(option)
          }"
          >
          <input
            type="radio"
            class="sr-only"
            [name]="groupName"
            [value]="option.value"
            [formControl]="resolvedControl"
            [disabled]="isOptionDisabled(option)"
            [attr.aria-invalid]="shouldShowError"
            (mousedown)="onOptionMouseDown($event, option)"
            (change)="onSelectionChange(option)"
            (blur)="markAsTouched()"
            />
          <span
            class="text-sm font-medium"
            [ngClass]="isOptionSelected(option) ? 'text-slate900' : 'text-slate700'"
            >
            {{ option.label }}
          </span>
          <span
            class="flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full border transition-colors"
            [ngClass]="isOptionSelected(option) ? 'border-indigo600 bg-indigo600 text-white' : 'border-slate300 bg-white'"
            >
            @if (isOptionSelected(option)) {
              <svg viewBox="0 0 20 20" fill="none" class="h-3 w-3">
                <path
                  d="M5 10.5L8.5 14L15 6.5"
                  stroke="currentColor"
                  stroke-width="2.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            }
          </span>
        </label>
      } @else {
        <label
          [class]="variant === 'plain' ? 'block transition-all duration-200' : 'block rounded-lg border bg-white px-3 py-2 transition-all duration-200'"
          [ngClass]="{
            'flex-1': stretch,
            'border-blue500 ring-2 ring-blue100': variant === 'card' && isOptionSelected(option) && !isOptionDisabled(option),
            'border-slate300 hover:border-slate400': variant === 'card' && !isOptionSelected(option) && !isOptionDisabled(option),
            'cursor-not-allowed border-slate200 bg-slate100 opacity-60': variant === 'card' && isOptionDisabled(option),
            'cursor-not-allowed opacity-60': variant === 'plain' && isOptionDisabled(option),
            'cursor-pointer': !isOptionDisabled(option)
          }"
          >
          <div
            class="flex items-center"
            [ngClass]="{
              'gap-3': variant === 'plain',
              'gap-4': variant !== 'plain',
              'w-full flex-row-reverse justify-between': variant === 'card' && radioPosition === 'right'
            }"
          >
            <input
              type="radio"
              [name]="groupName"
              [value]="option.value"
              [formControl]="resolvedControl"
              [disabled]="isOptionDisabled(option)"
              [attr.aria-invalid]="shouldShowError"
              (mousedown)="onOptionMouseDown($event, option)"
              (change)="onSelectionChange(option)"
              (blur)="markAsTouched()"
              class="h-4 w-4 border-slate300 accent-indigo-600 disabled:cursor-not-allowed"
              />
            <span class="text-sm text-slate800" [ngClass]="{ 'text-slate500': isOptionDisabled(option) }">
              {{ option.label }}
            </span>
          </div>
        </label>
      }
    }
  </div>

  <div class="mt-1.5 min-h-5 text-xs">
    @if (shouldShowError) {
      <p class="text-red600">{{ firstErrorMessage }}</p>
    }
  </div>
</div>
